(() => {
  const initializeStickyAtc = () => {
    const sticky = document.querySelector('[data-mahj-sticky-atc]');
    if (!sticky) return;

    const productInfo = sticky.closest('product-info');
    const form = document.getElementById(sticky.dataset.formId);
    const submitButton = sticky.querySelector('[data-sticky-submit]');
    const submitLabel = sticky.querySelector('[data-sticky-submit-label]');
    const priceSource = productInfo?.querySelector(`#price-${sticky.dataset.sectionId}`);
    const priceTarget = sticky.querySelector('[data-sticky-price]');
    const visibilityTarget = form?.closest('.product-form__buttons') || form;

    if (!form || !submitButton || !visibilityTarget) return;

    let stickyHeight = 0;
    let isPastPurchaseForm = false;
    const chatOffsets = new WeakMap();
    const formsOffsets = new WeakMap();

    const syncChatOffset = (shouldRaise) => {
      const chat = document.querySelector('shopify-chat');
      if (!chat) return false;

      if (!chatOffsets.has(chat)) {
        const computedStyle = getComputedStyle(chat);
        const captureOffset = (property) => ({
          inlineValue: chat.style.getPropertyValue(property),
          inlinePriority: chat.style.getPropertyPriority(property),
          baseValue: chat.style.getPropertyValue(property) || computedStyle.getPropertyValue(property).trim() || '0px',
        });

        chatOffsets.set(chat, {
          agent: captureOffset('--shopify-agent-activator-offset'),
          legacy: captureOffset('--shopify-chat-activator-offset'),
        });
      }

      const offsets = chatOffsets.get(chat);
      const updateOffset = (property, offset) => {
        if (shouldRaise) {
          chat.style.setProperty(
            property,
            `calc(${offset.baseValue} + var(--mahj-sticky-atc-height, 0px))`,
            offset.inlinePriority
          );
        } else if (offset.inlineValue) {
          chat.style.setProperty(property, offset.inlineValue, offset.inlinePriority);
        } else {
          chat.style.removeProperty(property);
        }
      };

      updateOffset('--shopify-agent-activator-offset', offsets.agent);
      updateOffset('--shopify-chat-activator-offset', offsets.legacy);
      return true;
    };

    const syncFormsOffset = (shouldRaise) => {
      const formEmbeds = [];
      document.querySelectorAll('shopify-forms-embed').forEach((host) => {
        formEmbeds.push(host);
        if (host.shadowRoot) {
          formEmbeds.push(...host.shadowRoot.querySelectorAll('[data-layout="floating"], [data-position]'));
        }
      });

      formEmbeds.forEach((formEmbed) => {
        if (getComputedStyle(formEmbed).position !== 'fixed') return;

        if (!formsOffsets.has(formEmbed)) {
          formsOffsets.set(formEmbed, {
            inlineBottom: formEmbed.style.getPropertyValue('bottom'),
            inlinePriority: formEmbed.style.getPropertyPriority('bottom'),
            baseBottom: getComputedStyle(formEmbed).bottom || '0px',
          });
        }

        const offset = formsOffsets.get(formEmbed);
        if (shouldRaise) {
          formEmbed.style.setProperty(
            'bottom',
            `calc(${offset.baseBottom} + var(--mahj-sticky-atc-height, 0px) + 12px)`,
            offset.inlinePriority
          );
        } else if (offset.inlineBottom) {
          formEmbed.style.setProperty('bottom', offset.inlineBottom, offset.inlinePriority);
        } else {
          formEmbed.style.removeProperty('bottom');
        }
      });
    };

    const updateHeight = () => {
      stickyHeight = sticky.getBoundingClientRect().height;
      document.body.style.setProperty('--mahj-sticky-atc-height', `${stickyHeight}px`);
      syncChatOffset(isPastPurchaseForm);
    };

    const updateVisibility = () => {
      const shouldShow = isPastPurchaseForm;
      sticky.hidden = false;
      sticky.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('mahj-sticky-atc-visible', shouldShow);
      document.body.style.setProperty('--mahj-sticky-atc-height', shouldShow ? `${stickyHeight}px` : '0px');
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      syncChatOffset(shouldShow);
      syncFormsOffset(shouldShow);
    };

    const updatePurchaseState = () => {
      const mainButton = form.querySelector('.product-form__submit');
      if (!mainButton) return;

      submitButton.disabled = mainButton.disabled;
      if (submitLabel) {
        const mainLabel = mainButton.querySelector('span:not(.loading-spinner)')?.textContent?.trim();
        if (mainLabel) submitLabel.textContent = mainLabel;
      }
    };

    const updatePrice = () => {
      if (priceSource && priceTarget) priceTarget.innerHTML = priceSource.innerHTML;
    };

    const updatePastFormState = () => {
      const rect = visibilityTarget.getBoundingClientRect();
      isPastPurchaseForm = rect.bottom <= 0;
      updateVisibility();
    };

    const observer = new IntersectionObserver(updatePastFormState, { threshold: 0 });
    observer.observe(visibilityTarget);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateHeight).observe(sticky);
    } else {
      updateHeight();
    }

    window.addEventListener('scroll', updatePastFormState, { passive: true });
    window.addEventListener('resize', updateHeight, { passive: true });
    form.addEventListener('change', updatePurchaseState);
    productInfo?.addEventListener('product-info:loaded', updatePurchaseState);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        updatePurchaseState();
        updatePrice();
      });
    }

    if (priceSource) {
      new MutationObserver(updatePrice).observe(priceSource, { childList: true, subtree: true });
    }

    if (!syncChatOffset(false)) {
      const chatObserver = new MutationObserver(() => {
        if (syncChatOffset(isPastPurchaseForm)) chatObserver.disconnect();
      });
      chatObserver.observe(document.body, { childList: true, subtree: true });
    }

    const formsObserver = new MutationObserver(() => syncFormsOffset(isPastPurchaseForm));
    formsObserver.observe(document.body, { childList: true, subtree: true });

    updateHeight();
    updatePurchaseState();
    updatePrice();
    updatePastFormState();
    syncFormsOffset(isPastPurchaseForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStickyAtc, { once: true });
  } else {
    initializeStickyAtc();
  }
})();
